// Enumerations
import { BiometricContextsEnum } from 'enumerations/biometric/biometric.enum';
// Utilities
import { loadBiometric } from 'utils/biometric/biometric.utils';
// Types
import type { BiometricContextHandlersPropsType } from './types/biometric.context-props.handlers.type';
import type { BiometricContextHandlersType } from './types/biometric.context.handlers.type';

const onCancelChallengeHandler = ({
  isChallenged,
  setChallengeCanceled,
}: BiometricContextHandlersPropsType) => {
  if (isChallenged) {
    setChallengeCanceled(true);
    loadBiometric(BiometricContextsEnum.CANCEL_CHALLENGE);
  }
};

const BiometricContextHandlers = ({
  isChallenged,
  setChallengeCanceled,
}: BiometricContextHandlersPropsType): BiometricContextHandlersType => ({
  onCancelChallenge: () => onCancelChallengeHandler({ isChallenged, setChallengeCanceled }),
});

export { BiometricContextHandlers };
